export default __webpack_public_path__ + "static/GlasgowHornets-05d73ea29f89298c274ed87c6fdfca72.jpg";